import { useQueryErrorStateContext } from 'modules/queryBuilder/contexts';

export const useResetQueryErrors = () => {
  const { resetErrorsFromFieldPath } = useQueryErrorStateContext();
  return () => resetErrorsFromFieldPath('');
};
